import Grid from '@mui/material/Grid';

import Drugcard from "../../../../../../components/Cards/DrugCard";

import Fluvastatin from "./Fluvastatin/Fluvastatin";
import Dia_fluvastatin from "./Fluvastatin/Dia_fluvastatin";

import Clopidogrel from "./Clopidogrel/Clopidogrel"
import Dia_clopidogrel from "./Clopidogrel/Dia_clopidogrel";

import NSAID from "./NSAID/NSAID";
import Dia_NSAID from "./NSAID/Dia_NSAID";

import Acenocoumarol from "./Acenocoumarol/Acenocoumarol.";
import Dia_acenocoumarol from "./Acenocoumarol/Dia_acenocoumarol";

import Atazanavir from "./Atazanavir/Atazanavir";
import Dia_atazanavir from "./Atazanavir/Dia_atazanavir";

import Celecoxib from "./Celecoxib/Celecoxib";
import Dia_celecoxib from "./Celecoxib/Dia_celecoxib";

import Citalopram from "./Citalopram/Citalopram";
import Dia_citalopram from "./Citalopram/Dia_citalopram";

import Clomipramine from "./Clomipramine/Clomipramine";
import Dia_clomipramine from "./Clomipramine/Dia_clomipramine";

import Efavirenz from "./Efavirez/Efavirenz";
import Dia_efavirenz from "./Efavirez/Dia_efavirenz";

import Dexlansoprazole from "./Dexlansoprazole/Dexlansoprazole";
import Dia_dexlansoprazole from "./Dexlansoprazole/Dia_dexlansoprazole";

import Doxepin from "./Doxepin/Doxepin";
import Dia_doxepin from "./Doxepin/Dia_doxepin";

import Desipramine from "./Desipramine/Desipramine";
import Dia_desipramine from "./Desipramine/Dia_desipramine";

import Escitalopram from "./Escitalopram/Escitalopram";
import Dia_escitalopram from "./Escitalopram/Dia_escitalopram";

import { useTheme } from "@mui/material";



export default function ModerateDrugs() {

const theme = useTheme();

return (
<>

{theme.palette.mode === "light" ? (

<Grid container sx={{mb:2, p:1, pl:2, display:'flex', justifyContent:'center', bgcolor: 'grey.C600', borderRadius: '10px'}}>   

                        <Grid item xs={9} >  <Acenocoumarol />        </Grid>
                        <Grid item xs={3} >  <Dia_acenocoumarol />    </Grid>

                        <Grid item xs={9} >  <Atazanavir />        </Grid>
                        <Grid item xs={3} >  <Dia_atazanavir />    </Grid>

                        <Grid item xs={9} >  <Celecoxib />        </Grid>
                        <Grid item xs={3} >  <Dia_celecoxib />    </Grid>

                        <Grid item xs={9} >  <Citalopram />        </Grid>
                        <Grid item xs={3} >  <Dia_citalopram />    </Grid>

                        <Grid item xs={9} >  <Clomipramine />        </Grid>
                        <Grid item xs={3} >  <Dia_clomipramine />    </Grid>

                        <Grid item xs={9} >  <Clopidogrel />        </Grid>
                        <Grid item xs={3} >  <Dia_clopidogrel />    </Grid>

                        <Grid item xs={9} >  <Desipramine />        </Grid>
                        <Grid item xs={3} >  <Dia_desipramine />    </Grid>

                        <Grid item xs={9} >  <Dexlansoprazole />        </Grid>
                        <Grid item xs={3} >  <Dia_dexlansoprazole />    </Grid>

                        <Grid item xs={9} >  <Doxepin />        </Grid>
                        <Grid item xs={3} >  <Dia_doxepin />    </Grid>

                        <Grid item xs={9} >  <Efavirenz />        </Grid>
                        <Grid item xs={3} >  <Dia_efavirenz />    </Grid>

                        <Grid item xs={9} >  <Escitalopram />        </Grid>
                        <Grid item xs={3} >  <Dia_escitalopram />    </Grid>


                        <Grid item xs={9} >  <Fluvastatin />        </Grid>
                        <Grid item xs={3} >  <Dia_fluvastatin />    </Grid>
                       
                        <Grid item xs={9} >  <NSAID />        </Grid>
                        <Grid item xs={3} >  <Dia_NSAID />    </Grid>
                        
                </Grid>

) : (


        <Grid container sx={{mb:2, p:1, pl:2, display:'flex', justifyContent:'center', bgcolor: 'secondary.C800', borderRadius: '10px'}}>    

                <Grid item xs={9} >  <Acenocoumarol />        </Grid>
                <Grid item xs={3} >  <Dia_acenocoumarol />    </Grid>

                <Grid item xs={9} >  <Atazanavir />        </Grid>
                <Grid item xs={3} >  <Dia_atazanavir />    </Grid>

                <Grid item xs={9} >  <Celecoxib />        </Grid>
                <Grid item xs={3} >  <Dia_celecoxib />    </Grid>

                <Grid item xs={9} >  <Citalopram />        </Grid>
                <Grid item xs={3} >  <Dia_citalopram />    </Grid>

                <Grid item xs={9} >  <Clomipramine />        </Grid>
                <Grid item xs={3} >  <Dia_clomipramine />    </Grid>

                <Grid item xs={9} >  <Clopidogrel />        </Grid>
                <Grid item xs={3} >  <Dia_clopidogrel />    </Grid>

                <Grid item xs={9} >  <Desipramine />        </Grid>
                <Grid item xs={3} >  <Dia_desipramine />    </Grid>

                <Grid item xs={9} >  <Dexlansoprazole />        </Grid>
                <Grid item xs={3} >  <Dia_dexlansoprazole />    </Grid>

                <Grid item xs={9} >  <Doxepin />        </Grid>
                <Grid item xs={3} >  <Dia_doxepin />    </Grid>

                <Grid item xs={9} >  <Efavirenz />        </Grid>
                <Grid item xs={3} >  <Dia_efavirenz />    </Grid>

                <Grid item xs={9} >  <Escitalopram />        </Grid>
                <Grid item xs={3} >  <Dia_escitalopram />    </Grid>


                <Grid item xs={9} >  <Fluvastatin />        </Grid>
                <Grid item xs={3} >  <Dia_fluvastatin />    </Grid>

                <Grid item xs={9} >  <NSAID />        </Grid>
                <Grid item xs={3} >  <Dia_NSAID />    </Grid>

                </Grid>
        )}
</>

)};
